var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.575,
    height: 14.998,
    viewBox: "0 0 8.575 14.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "listRightArrow",
    d: "M17.237,13.692,11.561,8.021a1.067,1.067,0,0,1,0-1.514,1.081,1.081,0,0,1,1.518,0l6.43,6.426a1.07,1.07,0,0,1,.031,1.478l-6.457,6.47a1.072,1.072,0,0,1-1.518-1.514Z",
    transform: "translate(-11.246 -6.196)",
    fill: "#5e2b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListRightArrow);
export default __webpack_public_path__ + "static/media/listRightArrow.a438eb0c30b3e6399c502e24a3c88219.svg";
export { ForwardRef as ReactComponent };